import { createApp } from 'vue';
import App from './App.vue';
import router from './router'
import store from './store'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import "./assets/css/base.less";
import './assets/icon/iconfont.css';
import './assets/icon/iconfont.js';
import './assets/iconfont/iconfont.css';
import './assets/iconfont/iconfont.js';
import './assets/icons/iconfont.css';
import './assets/icons/iconfont.js';
import './permission';
import TitleView from "@/components/title";
import SearchView from "@/components/search";
import Spot from "@/components/spot";
import EmptyComp from "@/components/empty/EmptyView";
import Layout from "@/components/layout";
import PartolView from "@/components/portal";
import CloudView from "@/components/cloud";
const app = createApp(App);
app.component('TitleView', TitleView);
app.component('Spot', Spot);
app.component('SearchView', SearchView);
app.component('EmptyComp', EmptyComp);
app.component('Layout', Layout);
app.component('PartolView', PartolView);
app.component('CloudView', CloudView);
app.use(Antd).use(store).use(router).mount('#app');
